<template>
  <section>
    <v-container>
      <v-layout row>
        <v-flex>
          <v-stepper non-linear>
            <v-stepper-header>
              <v-stepper-step
                editable
                step="1">Step 1</v-stepper-step>
              <v-divider/>
              <v-stepper-step
                editable
                step="2">Step2</v-stepper-step>
              <v-divider/>
              <v-stepper-step
                editable
                step="3">Step 3</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-12">
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md8>
                      <label>
                        Project / Workload Title
                      </label>
                      <v-text-field
                        v-model="newWorkload.oppproject.Workload_Title">
                        <v-tooltip
                          slot="append"
                          left>
                          <v-icon
                            slot="activator"
                            color="primary"
                            dark>info</v-icon>
                          <span>Use a short phrase to describe theworkload, i.e. Legacy DC Migration,Virtual Desktop Migration or Hybrid Cloud Transformation</span>
                        </v-tooltip>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md8>
                      <label>Enter the DXC campaign name if applicable</label>
                      <v-text-field
                        v-model="newWorkload.oppproject.Campaign_Name"
                        solo
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="newWorkload.oppproject.Campaign_Name.includes('Glacier')" class="sow-field">
                    <v-flex
                      md8
                      class="pt-2">
                      <label>Glacier SOW Qty <span class="required">*</span></label>
                      <p>If your Glacier OPX is only for Assess Phase, please select zero in the SOW drop down.</p>
                      <p>If the SOW quantity changes in the future, please notify <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a> and the DXC Oppreg admin team will update the record.</p>
                    </v-flex>
                    <v-flex md2 >
                      <v-select
                        v-validate="{ required: true }"
                        :items="['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10']"
                        v-model="newWorkload.oppproject.Scope_of_Work"
                        :error-messages="errors.collect('Scope_of_Work')"
                        data-vv-validate-on="blur"
                        placeholder="Select an option"
                        data-vv-name="Scope_of_Work"
                        solo
                        attach
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      sm12 
                      md8
                    >
                      <label>Select from the drop down list the DXC business segment that best describes the overall OPX</label>
                      <v-select
                        v-model="newWorkload.oppproject.Solution_Business_Segment"
                        :items="solutionBusinessSegments"
                        label="Please select one"
                        required
                        solo
                        attach
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>
                        Will the AWS cloud environment be used for {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }} internal use only?
                      </label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q1A" >
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q1A === 'Y' } "
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q1A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>
                        Will the cloud environment be used for a SaaS or other software solution where {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }}’s client will have access only to the application and not to the AWS cloud environment?
                      </label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q2A" >
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q2A === 'Y' }"
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q2A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>
                        Are you moving an existing DXC managed workload into an AWS cloud environment?
                      </label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q3A">
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q3A === 'Y' }"
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q3A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>
                        Has {{ opportunityForGainwell ? 'DXC/Gainwell' : 'DXC' }} been managing the existing workload beginning on or before September 1, 2018 up until the present (for example, is {{ opportunityForGainwell ? 'DXC/Gainwell' : 'DXC' }} hosting the workload in a {{ opportunityForGainwell ? 'DXC/Gainwell' : 'DXC' }} center or providing application services for the workload?)
                      </label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q4A">
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q4A === 'Y' }"
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q4A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md8
                      xl8>
                      <label>Attestation: I attest that this workload was under DXC/Gainwell management as of September 1, 2018 (Your name will serve as your signature)</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md4
                      xl4>
                      <v-text-field
                        :disabled="newWorkload.wlqa.WL_Q4A !== 'Y'"
                        disabled
                        v-model="newWorkload.wlqa.Attested_By"/>
                        <!-- <v-layout column align-end>
                        <v-flex>
                          <v-btn-toggle>
                            <v-btn>Yes</v-btn>
                            <v-btn>No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>-->
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>Has the workload been hosted on AWS before now?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q5A">
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q5A === 'Y' }"
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q5A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      md10
                      pt-2>
                      <label>Will {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }}’s client expectation be to have ongoing root/administrative access to the AWS virtual machines, (e.g. are we selling {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }} Managed Services for AWS Silver)?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.wlqa.WL_Q6A">
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q6A === 'Y' }"
                              class="black--text btn--qa"
                              value="Y"
                            >Yes</v-btn>
                            <v-btn
                              disabled
                              :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q6A === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card class="mb-12">
                  <v-layout
                    row
                    wrap>
                    <v-flex md12>
                      <label>Give a high-level description of the opportunity.</label>
                      <v-textarea
                        disabled
                        v-validate="{ required: true }"
                        v-model.lazy="newWorkload.wlqa.DXC_Services"
                        :error-messages="errors.collect('DXC_Services')"
                        data-vv-name="DXC_Services"
                        data-vv-validate-on="blur"
                        solo
                      />
                    </v-flex>
                    <v-flex md12>
                      <label class="mr-3">Will the opportunity include {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }} Managed Services? Y/N</label>
                      <v-btn-toggle v-model="newWorkload.wlqa.DXC_SA1">
                        <v-btn
                          disabled
                          id="q1"
                          :class="{ 'v-btn--active': newWorkload.wlqa.DXC_SA1 === 'Y' }"
                          value="Y"
                          class="black--text btn--qa">Yes</v-btn>
                        <v-btn
                          disabled
                          :class="{ 'v-btn--active': newWorkload.wlqa.DXC_SA1 === 'N' }"
                          value="N"
                          class="black--text btn--qa">No</v-btn>
                      </v-btn-toggle>
                    </v-flex>
                    <v-flex>
                      <label>What {{ opportunityForGainwell ? 'Gainwell' : 'DXC' }} services or solutions will be provided for the client’s AWS cloud environment (other than the AWS services, including AMS)?</label>
                      <v-text-field
                        disabled
                        v-validate="{ required: true }"
                        v-model.lazy="newWorkload.wlqa.DXC_SA2"
                        :error-messages="errors.collect('DXC_SA2')"
                        data-vv-name="DXC_SA2"
                        data-vv-validate-on="blur"
                        solo
                      />
                    </v-flex>
                    <v-flex>
                      <div class="aws-services-options mt-3">
                        <label>
                          Will the solution incorporate any of the following AWS Services? Click all that apply.
                        </label>
                        <div
                          v-for="(service,index) in computedAwsServices"
                          :key="computedAwsServices[index].text "
                        >
                          <v-checkbox
                            disabled
                            v-model="service.selected"
                            :label="service.text"
                            class="aws-option"
                            color="orange"
                          />
                        </div>
                      </div>

                      <div class="aws-regions mt-3">
                        <label>Will the services be provided in a region listed at the following link? <a
                          href="https://regionslist.s3.amazonaws.com/Eligible+Regions.pdf"
                          target="_blank">https://regionslist.s3.amazonaws.com/Eligible+Regions.pdf</a></label>
                        <v-layout>
                          <v-flex>
                            <v-btn-toggle v-model="newWorkload.wlqa.WL_Q8A">
                              <v-btn
                                disabled
                                id="q1"
                                :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q8A === 'Y' }"
                                value="Y"
                                class="black--text btn--qa">Yes</v-btn>
                              <v-btn
                                disabled
                                :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q8A === 'N' }"
                                value="N"
                                class="black--text btn--qa">No</v-btn>
                            </v-btn-toggle>
                          </v-flex>
                        </v-layout>
                        <label>Please review the regions at the link, and if not listed, state which AWS region(s) here.</label>
                        <v-layout
                          row
                          wrap>
                          <v-flex
                            md6
                            sm12>
                            <v-text-field
                              disabled
                              v-model="newWorkload.wlqa.WL_Q9A"/>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-layout
                        row
                        wrap>
                        <v-flex
                          md6
                          class="pt-2">
                          <label>
                            What is the monthly estimated AWS spend for this opportunity (in USD)
                          </label>
                          <p>If you are unsure, Feel free to use these estimates.
                            <ul>
                              <li>Migrations or SaaS $15,000 per month (or greater)</li>
                              <li>SAP Migration $20,000 per month (or greater)</li>
                              <li>Managed Services $20,000 per month (or greater)</li>
                            </ul>
                          </p>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            disabled
                            v-validate="'required|decimal:2'"
                            v-model="newWorkload.wlqa.WL_Q10A"
                            type="number"
                            prepend-icon="attach_money"
                            class="padding-left-15"
                            solo
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card class="mb-12">
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <span style="font-weight: bold">
                        Contact Information
                      </span>
                      <v-layout
                        row
                        wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="workload.contact.Contact_First_Name"
                            placeholder="First Name"
                            readonly
                            solo
                          />
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="workload.contact.Contact_Last_Name"
                            placeholder="Last Name"
                            solo
                            readonly
                            required
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout
                        row
                        wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="workload.contact.Contact_Email"
                            placeholder="Contact email"
                            solo
                            readonly
                          />
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="workload.contact.Contact_Phone"
                            placeholder="Contact phone"
                            solo
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
      <v-layout
        row>
        <v-flex>
          <h3 mt-1>
            Current Workload Type:
            <span>{{ newWorkload.oppproject.Workload_type }}</span>
          </h3>
        </v-flex>
        <v-flex>
          <h3 v-if="workloadType"
              mt-1>
            New Calculation:
            <span>{{ workloadType }}</span>
          </h3>
        </v-flex>
        <v-flex style="text-align: right">
          <v-btn
            :loading="workload.submitting"
            class="opp-btn"
            color="warning"
            @click="onUpdateQuestionnaire">Update Questionnaire</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      sameAsLoggedInUser: false,
      awsServicesRegions: [
        {
          text: 'US East (N.Virginia)',
          value: 'US East (N.Virginia)',
          selected: false
        },
        {
          text: 'Asia Pacific (Mumbai)',
          value: 'Asia Pacific (Mumbai)',
          selected: false
        },
        { text: 'US East (Ohio)', value: 'US East (Ohio)', selected: false },
        {
          text: 'Asia Pacific (Osaka)',
          value: 'Asia Pacific (Osaka)',
          selected: false
        },
        {
          text: 'US West (N.California)',
          value: 'US West (N.California)',
          selected: false
        },
        {
          text: 'Asia Pacific (Seoul)',
          value: 'Asia Pacific (Seoul)',
          selected: false
        },
        {
          text: 'US West (Oregon)',
          value: 'US West (Oregon)',
          selected: false
        },
        {
          text: 'Asia Pacific (Singapore)',
          value: 'Asia Pacific (Singapore)',
          selected: false
        },
        {
          text: 'Canada (Central)',
          value: 'Canada (Central)',
          selected: false
        },
        {
          text: 'Asia Pacific (Sydney)',
          value: 'Asia Pacific (Sydney)',
          selected: false
        },
        { text: 'EU (Frankfurt)', value: 'EU (Frankfurt)', selected: false },
        {
          text: 'Asia Pacific (Tokyo)',
          value: 'Asia Pacific (Tokyo)',
          selected: false
        },
        { text: 'EU (Ireland)', value: 'EU (Ireland)', selected: false },
        {
          text: 'South America (Sao Paolo)',
          value: 'South America (Sao Paolo)',
          selected: false
        },
        { text: 'EU (Paris)', value: 'EU (Paris)', selected: false },
        { text: 'GovCloud (US)', value: 'GovCloud (US)', selected: false },
        { text: 'UK (London)', value: 'UK (London)', selected: false }
      ],
      awsServices: [
        {
          text: 'Alexa Web Information Service',
          value: 'Alexa Web Information Service',
          selected: false
        },
        {
          text: 'Amazon Registrar',
          value: 'Amazon Registrar',
          selected: false
        },
        {
          text: 'Aws Marketplace Beta Services',
          value: 'Aws Marketplace Beta Services',
          selected: false
        },
        {
          text: 'Amazon S3 Glacier Deep Archive',
          value: 'Amazon S3 Glacier Deep Archive',
          selected: false
        },
        {
          text: 'Deep Archive',
          value: 'Deep Archive',
          selected: false
        },
         {
          text: 'AWS IQ',
          value: 'AWS IQ',
          selected: false
        },
        { text: 'Not Applicable', value: 'Not Applicable', selected: false }
      ],
      solutionBusinessSegments: [
        'DXC Insurance Software Business (ISB)',
        'DXC Consulting & Engineering Services (CES)',
        'DXC Global Infrastructure Services (GIS)',
      ]
    }
  },
  computed: {
    ...mapState('admin/oppregAdmin', ['workload', 'newWorkload']),
    opportunityForGainwell () {
      return !this.workload.opportunity.Opportunity_Id.indexOf('DXCGNW')
    },
    computedAwsServices: {
      get: function () {
        // TODO hardcode for now, later get value from state
        // let workloadAwsServices = ['Alexa Web Information Service', 'Amazon S3 Glacier Deep Archive', 'Not Applicable']
        let workloadAwsServices = JSON.parse(this.newWorkload.wlqa.WL_Q7A)
        let awsServices = this.awsServices.map((service, index) => {
          let serviceFound = workloadAwsServices.some(
            value => value === service.value
          )
          if (serviceFound) {
            return { ...service, selected: true }
          } else {
            return { ...service, selected: false }
          }
        })
        return awsServices
      }
    },
    workloadType () {
      let newWorkloadTypeCalculation
      // Q1 Logic
      if (this.newWorkload.wlqa.WL_Q1A === 'Y') {
        newWorkloadTypeCalculation = 'PPA'
      }
      // Q2 Logic
      if (this.newWorkload.wlqa.WL_Q2A === 'Y') {
        newWorkloadTypeCalculation = 'PPA'
      }
      // Q3 Logic
      if (this.newWorkload.wlqa.WL_Q3A === 'N' && this.newWorkload.wlqa.WL_Q1A === 'N' && this.newWorkload.wlqa.WL_Q2A === 'N') {
        newWorkloadTypeCalculation = 'SPP'
      } else if (this.newWorkload.wlqa.WL_Q3A === 'N' && (this.newWorkload.wlqa.WL_Q1A === 'Y' || this.newWorkload.wlqa.WL_Q2A === 'Y')) {
        newWorkloadTypeCalculation = 'PPA'
      }
      // Q4 Logic
      if (this.newWorkload.wlqa.WL_Q4A === 'Y' && this.newWorkload.wlqa.WL_Q3A === 'Y') {
        newWorkloadTypeCalculation = 'PPA'
      } else if (this.newWorkload.wlqa.WL_Q4A === 'N' && (this.newWorkload.wlqa.WL_Q1A === 'N' && this.newWorkload.wlqa.WL_Q2A === 'N')) {
        newWorkloadTypeCalculation = 'SPP'
      } else if (this.newWorkload.wlqa.WL_Q4A === 'N' && (this.newWorkload.wlqa.WL_Q1A === 'Y' || this.newWorkload.wlqa.WL_Q2A === 'Y')) {
        newWorkloadTypeCalculation = 'PPA'
      }
      // Q5 & Q6 Logic
      if (this.newWorkload.wlqa.WL_Q5A === 'Y' || this.newWorkload.wlqa.WL_Q6A === 'Y') {
        newWorkloadTypeCalculation = 'SPP'
      }
      return newWorkloadTypeCalculation
    }
  },
  methods: {
    ...mapActions({
      updateQuestionnaire: 'admin/oppregAdmin/updateQuestionnaire'
    }),
    onUpdateQuestionnaire: function () {
      console.log(this.newWorkload.oppproject,)
      let questionnaireUpdates = {
        answers: this.newWorkload.oppproject, 
        id: this.newWorkload.oppproject.Registration_Id, 
        type: this.newWorkload.workloadType ? this.newWorkload.workloadType : this.newWorkload.oppproject.Workload_type
      }

      this.updateQuestionnaire(questionnaireUpdates)
      // this.updateQuestionnaire({ answers: this.newWorkload.wlqa, id: this.newWorkload.oppproject.Registration_Id, type: this.workloadType })
    },
    // onQuestionOneChange: function (answer) {
    //   if (answer === 'Y') {
    //     this.$store.commit('admin/oppregAdmin/clearQuestionnaireNextAnswers', 1)
    //   }
    // },
    // onQuestionTwoChange: function (answer) {
    //   if (answer === 'Y') {
    //     this.$store.commit('admin/oppregAdmin/clearQuestionnaireNextAnswers', 2)
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.disable-events {
  pointer-events: none;
}

.v-btn-toggle {
  margin: 10px 0;
}
.v-btn-toggle .v-btn {
  padding: 15px 25px;
  opacity: 0.7px;
}
.btn--qa {
  font-weight: bold !important;
}
.v-btn--active:before,
.v-btn:focus:before,
.v-btn:hover:before {
  background-color: grey;
}
.v-btn-toggle .v-btn.v-btn--active{
    background-color: #ff9900 !important;
}
.sow-field {
  margin-bottom: 40px;
}
</style>